import { useMsal } from '@azure/msal-react';
import { Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

interface IProps{
  handleLoginAuthenticatedSSO: (data:string) => void,
  textScreen?:string,
}
const AzureAuthentication : React.FC<IProps> = ({ handleLoginAuthenticatedSSO, textScreen }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { instance } = useMsal();
  const loginRequest = { scopes: ['User.Read'] }; // { scopes: ['openid', 'profile'] }
  const [typographyScreen, setTypographyScreen] = useState<string>(String(textScreen));
  const logIn = (): any => {
    // Azure Login
    instance.loginRedirect(loginRequest).catch((e) => {
      setTypographyScreen('シングルサインオンに失敗しました');
      sessionStorage.clear();
      // console.error(e);
    });
  };

  useEffect(() => {
    instance.handleRedirectPromise()
      .then((tokenResponse) => {
        if (!tokenResponse) {
          const accounts = instance.getAllAccounts();
          if (accounts.length === 0) {
            // No user signed in
            setTypographyScreen('シングルサインオンを開始します');
            logIn();
          }
        } else {
          sessionStorage.clear();
          tokenResponse?.accessToken && handleLoginAuthenticatedSSO(tokenResponse?.accessToken);
        }
      })
      .catch((err) => {
        // Handle error
        setTypographyScreen('シングルサインオンに失敗しました');
        // console.error(err);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Typography id="authentication" style={{ fontSize: '2rem', minWidth: '100vw', textAlign: 'center' }}>
      {textScreen || typographyScreen}
    </Typography>
  );
};

export default AzureAuthentication;
